import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserGroup } from "../../../../shared/models/user-group";
import { User } from "../../../../shared/models/user";
import { SearchedUserPipe } from "../member-search/searched-user.pipe";
import { Session } from "../../../../services/session.service";
import { applicationType } from '../team-users.component';

@Component({
    selector: 'app-member-group',
    templateUrl: './member-group.component.html',
    styleUrls: ['./member-group.component.scss'],
    standalone: false
})
export class MemberGroupComponent implements OnInit {
  @Input() group: UserGroup;
  @Input() projectLocked: boolean = false;
  @Input() alreadyMember: boolean = false;
  @Input() isSearch: boolean = false;
  @Input() hideWordSearched: boolean = false;
  @Input() applicationType: number;
  @Input() foundUserName: string = ""; //should display user from members that matches
  @Output() addSignal: EventEmitter<UserGroup> = new EventEmitter<UserGroup>();
  @Output() deleteSignal: EventEmitter<UserGroup> = new EventEmitter<UserGroup>();

  othersCount: number = 0;
  displayUserName: string = "";
  canEdit: boolean = true;
  appType = applicationType;

  constructor(private searchedUser: SearchedUserPipe,
              private session: Session) {
  }

  ngOnInit() {
    if(!this.hideWordSearched) {
      this.othersCount = this.group.members.length - 1;
      this.matchingUser();
    }
    this.canEdit = this.session.getPermissionToShow.canCreateEditUsersUserGroups;
  }

  addGroup() {
    this.addSignal.emit(this.group);
  }

  deleteGroup() {
    this.deleteSignal.emit(this.group);
  }

  expandToggle() {
    if( !this.alreadyMember || !this.isSearch ) {
      this.group.expanded = !this.group.expanded;
    }
  }

  matchingUser() {
    let matchingUsers = this.group.members.filter( item => {
      return item.member.name.toLowerCase().includes(this.foundUserName.toLowerCase());
    });
    if(matchingUsers.length > 0) {
      this.displayUserName = matchingUsers[ 0 ].member.name;
    } else { //if found due to group name matching, there are no users with that name to show
      this.displayUserName = "";
    }
  }

}
